<template>
    <div>
        <div :key="index"
             v-for="(subscription, index) in subscriptionList">
            <address-item
                :should-expand="expandedSubscriptionId === subscription.id"
                :address-id="subscription.delivery_address_id"
                :allow-cancel="allowCancel"
                :allow-edit="isActive"
                :allow-restart="!isActive"
                :subscription-id="subscription.id"
                @closeList="$emit('closeList')"
                @expandSubscription="handleSubscriptionExpand">
            </address-item>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressItem from '@/components/partials/account/my-delivery-addresses/AddressItem';

export default {
    name: 'AddressList',
    data() {
        return {
            expandedSubscriptionId: 0,
        };
    },
    props: {
        subscriptions: {
            type: Array,
        },
        type: {
            type: String,
            default: 'active',
            validator: function(value) {
                // The value must match one of these strings
                return ['active', 'inactive'].indexOf(value) !== -1;
            },
        },
        unique: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAllSubscriptions');
    },
    methods: {
        /**
         * Handle the subscription expanded event.
         *
         * @param {number} subId
         *
         * @returns {void}
         */
        handleSubscriptionExpand(subId) {
            this.expandedSubscriptionId = subId;
        },
    },
    computed: {
        ...mapGetters({
            userCanCancel: 'subscription/allowCancel',
            addresses: 'address/getAddresses',
            getAddress: 'address/getAddressById',
        }),
        isActive() {
            return this.type === 'active';
        },
        allowCancel() {
            return this.isActive && this.userCanCancel;
        },
        subscriptionList() {
            let subscriptions = this.subscriptions
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            // Should we remove duplicates?
            if (this.unique === true && this.addresses && this.addresses.length) {
                let addresses = [];

                subscriptions = subscriptions.filter((item) => {
                    let addressSummary = this.getAddress(item.delivery_address_id).summary_string;
                    let shouldKeep = addresses.includes(addressSummary) === false;

                    addresses.push(addressSummary);

                    return shouldKeep;
                });
            }

            return subscriptions;
        },
    },
    components: {
        AddressItem,
    },
};
</script>
